<template>
  <div id="user-manage-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main um-modal">
      <div class="title-area" id="modal-moving">
        <div
        class="cross_btn"
        @click="onCancel"
        >
        <span class="css-cancel"></span>
        </div>
        <h2>ユーザー管理</h2>
      </div>
      <div class="data-area">
        <div class="upper">
          <button class="main_btn" @click="onClickAddUser">新規ユーザーの追加</button>
        </div>
        <table>
          <tbody>
            <tr>
              <th>管理番号</th>
              <th>タイプ</th>
              <th>氏名</th>
              <th>ID/メールアドレス</th>
              <th>最終ログイン日</th>
              <th class="hid_th md"></th>
              <th class="hid_th sm" ></th>
              <th class="hid_th sm"></th>
            </tr>
            <tr v-if="userList && userList.length > 0" v-for="(user, index) in userList" :key="index">
              <td>{{ user.userId }}</td>
              <td>{{ getUserTypeName(user.userType) }}</td>
              <td>{{ user.userLastName }} {{user.userFirstName}}</td>
              <td>{{ user.email }}</td>
              <td>{{ lastLogin(user.userId) }}</td>
              <td class="hid_td"><button class="main_btn" @click="onResetPass(user.email)">パスワードリセット</button></td>
              <td class="hid_td"><button class="main_btn" @click="onEdit(user)">編集</button></td>
              <td class="hid_td"><button class="main_btn" @click="onDel(user)">削除</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import store from '../../store/index'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
import { USER_TYPE } from '../../constants/Type'
export default {
  name: 'UserManageModal',
  store: store,
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル判定 */
      modalShown: false
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      userList: state => state.userList
    })
  },
  methods: {
    ...mapActions({ getUserList: 'loadUserList' }),
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onClickAddUser: function () {
      App.showUserModal(true, false)
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    onEdit: function (userObj) {
      App.showUserModal(false, false, userObj)
    },
    onDel: function (userObj) {
      App.showUserModal(false, true, userObj)
    },
    onResetPass: function (email) {
      let modalData = {
        messages: ['パスワードをリセットしますがよろしいでしょうか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          this.$refs.loadingModalRef.showModal(true)
          let payload = {
            loginId: email
          }
          axios.post(API_URL.ADMIN + '/reset-pass', payload
          ).then(response => {
            this.$refs.loadingModalRef.showModal(false)
            let modalData2 = {
              messages: ['パスワード初期化完了', '仮パスワードをメール送信しました。']
            }
            App.showModal(modalData2)
          }).catch(error => {
            Api.handleError(error)
          })
        }
      }
      App.showModal(modalData)
    },
    /** 最終ログイン日時 */
    lastLogin: function (id) {
      if (this.userList && this.userList.length > 0) {
        // idで該当するユーザーを検索
        let userObj = this.userList.find(obj => { if (obj.userId === id) return obj })
        if (userObj.userLastlogindt === null) {
          return ''
        } else {
          return moment(userObj.userLastlogindt).format('YYYY/MM/DD HH:mm:ss')
        }
      }
    },
    getUserTypeName: function (type) {
      let typeName = type
      Object.keys(USER_TYPE).map(key => {
        if (USER_TYPE[key].code === type) {
          typeName = USER_TYPE[key].label
        }
      })
      return typeName
    }
  },
  mounted: function () {
    this.$store.dispatch('loadUserList', {reload: true})
  }
}
</script>
<style lang="scss" scoped>
.upper{
  margin-bottom: 30px;
  text-align: left;
}
.data-area {
  margin: 40px auto;
}
.title-area {
  display:flex;
}
.um-modal {
  max-height: 100%;
  max-width: 1500px;
  padding-left: 40px;
  padding-right: 40px;
}
table{
  text-align: center;
}
h2{
  margin: auto;
  padding-right: 29px;
}
.hid_th{
  background:none;
  border: none;
}
.sm {
  width: 35px;
}
.md{
  width: 127px
}
.hid_td{
  border:none;
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/UserManageModal.vue